import React, { useEffect, useState } from "react";
import {
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const PasswordField = ({
  label,
  value,
  onChange,
  onBlur,
  error = false,
  helperText = "",
  autoFocus = false,
  fullWidth = true,
  size = "small",
  disabled = false,
  name,
  id,
  autoComplete = "new-password",
  required = false,
  sx,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    if (!value) {
      setShowPassword(false);
    }
  }, [value]);

  return (
    <TextField
      label={label}
      name={name}
      id={id}
      type={showPassword ? "text" : "password"}
      value={value}
      onChange={onChange}
      fullWidth={fullWidth}
      variant="outlined"
      size={size}
      autoFocus={autoFocus}
      disabled={disabled}
      error={error}
      helperText={helperText}
      autoComplete={autoComplete}
      required={required}
      onFocus={() => setFocused(true)}
      onBlur={(event) => {
        setFocused(false);
        onBlur?.(event);
      }}
      InputLabelProps={{
        shrink: focused || Boolean(value),
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={showPassword ? "Hide password" : "Show password"}
              onClick={() => setShowPassword((prev) => !prev)}
              onMouseDown={(event) => event.preventDefault()}
              edge="end"
              size="small"
              sx={{ color: "text.secondary", p: 0.5 }}
            >
              {showPassword ? (
                <VisibilityOff sx={{ fontSize: 18 }} />
              ) : (
                <Visibility sx={{ fontSize: 18 }} />
              )}
            </IconButton>
          </InputAdornment>
        ),
      }}
      sx={sx}
      {...rest}
    />
  );
};

export default PasswordField;
